import Gallery, { GalleryFillRow } from "components/Media/Gallery";
import { createDate, importAll, transformImages } from "utils";

import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        The goblin looked at it closely. ‘That seems to be in order.’ ‘An’ I’ve
        also got a letter here from Professor Dumbledore,’ said Hagrid
        importantly, throwing out his chest. ‘It’s about the You- Know-What in
        vault seven hundred and thirteen.’ The goblin read the letter carefully.
        ‘Very well,’ he said, handing it back to Hagrid, ‘I will have someone
        take you down to both vaults. Griphook!’
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable (though sealed), authentic replica of Dumbledore’s
        letter to the Gringotts Head Goblin. This is the letter Hagrid hands
        over during his visit to Gringotts with Harry to retrieve funds for
        school supplies. Since the contents of the letter are never revealed in
        the film, I designed Dumbledore’s message myself and sealed it inside
        the envelope - just as it appears on screen.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={transformImages(gallery)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="350px"
        fillRowAt={GalleryFillRow.end}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        I wasn’t able to find any reference photos of the original prop, so my
        only source was the first film. While we never get a clear view of the
        front of the envelope, it’s reasonable to assume it follows the standard
        Hogwarts style. The biggest challenge was determining the color of the
        ink. The books offer no detailed description, and due to the film’s dark
        lighting and color grading, I couldn’t confidently identify the ink
        color from the scene. It’s possible that the original prop used green
        ink to match the Hogwarts acceptance letters, but I have my reasons to
        believe that may not be the case. In the end, I chose a non-green ink to
        distinguish Dumbledore’s personal correspondence from the standard
        acceptance letters, as those were not written by him.
      </ReplicaParagraph>
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
